import tw, { styled } from 'twin.macro'
import { ChevronRightIcon } from '@components/Icons'
import { useState } from 'react'
import SocialMediaSettingsLightbox from './SocialMediaSettingsLightbox'

const Container = styled.div`
  ${tw`flex justify-between`}
`

const Title = styled.div`
  ${tw`text-c1-d`}
`

const SocialMediaSettings = () => {
  const [isLightboxVisible, setIsLightboxVisible] = useState(false)

  const openLightbox = () => setIsLightboxVisible(true)
  const closeLightbox = () => setIsLightboxVisible(false)

  return (
    <>
      <Container onClick={openLightbox}>
        <Title>社群設定</Title>
        <ChevronRightIcon width="16" height="16" />
      </Container>
      {isLightboxVisible && <SocialMediaSettingsLightbox close={closeLightbox} />}
    </>
  )
}

export default SocialMediaSettings
